// Select2
import 'select2';

$('#product .select2x').select2({
  theme: 'material',
  minimumResultsForSearch: -1,
  allowClear: false,
  closeOnSelect: true,
  dropdownParent: '#product',
  language: 'vi'
});


// Bootstrap slider
import 'bootstrap-slider';


// Vertical gallery slider
$('.slider-main').slick({
  slidesToShow: 1,
  arrows: false,
  asNavFor: '.slider-nav',
  vertical: true,
  autoplay: false,
  verticalSwiping: true,
  centerMode: false
});

$('.slider-nav').slick(
  {
    slidesToShow: 3,
    arrows: false,
    asNavFor: '.slider-main',
    vertical: true,
    focusOnSelect: true,
    verticalSwiping: false,
    autoplay: false,
    centerMode: false
  });

  $(".slider-nav-gallery .slider").slick({
    arrows: true,
    infinite: false,
    dots: false,
    centerMode: false,
    slidesToShow: 2,
    slidesToScroll: 1,    
    centerPadding: '0px',
    prevArrow: '<div class="slick-prev" style="left: -10px;z-index: 99;top: 45%;"><i style="color:#BC944E;font-size:24px" class="material-icons">keyboard_arrow_left</i></div>',
    nextArrow: '<div class="slick-next" style="right: 10px;z-index: 99;top: 45%;"><i style="color:#BC944E;font-size:24px" class="material-icons">keyboard_arrow_right</i></div>',   
  });
  
//on resizing the window fix to broken responsiveness
$(window).on('resize orientationchange', function () {
  $('.slider-main').slick('unslick');
  $('.slider-nav').slick('unslick');

  $('.slider-main').slick({
    slidesToShow: 1,
    arrows: false,
    asNavFor: '.slider-nav',
    vertical: true,
    autoplay: false,
    verticalSwiping: true,
    centerMode: false
  });
  $('.slider-nav').slick(
    {
      slidesToShow: 3,
      asNavFor: '.slider-main',
      arrows: false,
      vertical: true,
      focusOnSelect: true,
      verticalSwiping: false,
      autoplay: false,
      centerMode: false
    });
});

// diamond moblie slider
$('.slider-main-mb').slick({
  autoplay: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: '<div style="height: auto;width: auto;left:-30px" class="slick-prev"><i style="color:#B48C72;font-size:40px" class="material-icons">keyboard_arrow_left</i></div>',
  nextArrow: '<div style="height: auto;width: auto;right: -30px;" class="slick-next"><i style="color:#B48C72;font-size:40px" class="material-icons">keyboard_arrow_right</i></div>',
});

$('.slider-nav-mb').slick(
  {
    slidesToShow: 3,
    slidesToScroll: 0,
    autoplay: false,
    arrows: false,
    accessibility: false,
    draggable: false,
    asNavFor: '.slider-main-mb',
    focusOnSelect: true,
    variableWidth: true
  });
  
$('.nav-container .next').click(function () {
  $('.slider-nav').slick('slickNext');
});
$('.nav-container .prev').click(function () {
  $('.slider-nav').slick('slickPrev');
});



  

// Catalog slider
let $tag = $('.tag-catalog');
if ($tag.length > 0) {
  $tag.find('.slider').slick({
    arrows: false,
    variableWidth: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
  });

  $tag.find('.next').click(function () {
    $tag.find('.slider').slick('slickNext');
  });
  $tag.find('.prev').click(function () {
    $tag.find('.slider').slick('slickPrev');
  });
}

// Khuyen mai
$(".stockclear .slider").slick({
  arrows: true,
  infinite: true,
  centerMode: true,
  slidesToShow: 4,
  slidesToScroll: 3,
  centerPadding: '150px',  
  prevArrow: '<div style="height: auto;width: auto;left:-40px" class="slick-prev"><i style="color:#BC944E;font-size:40px" class="material-icons">keyboard_arrow_left</i></div>',
  nextArrow: '<div style="height: auto;width: auto;right: -40px;" class="slick-next"><i style="color:#BC944E;font-size:40px" class="material-icons">keyboard_arrow_right</i></div>',
  responsive: [
    {
    breakpoint: 1000,
    settings: {
      slidesToShow: 2,
        centerPadding: '100px',
        slidesToScroll: 2 
    }
  },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        centerPadding: '100px',
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 3,
        centerPadding: '50px',
      }
    }
  ]
});

$(".stockclear1 .sliderhome").slick({
  arrows: true,
  infinite: true,
  slidesToShow: 6,
  slidesToScroll: 6,
  centerPadding: '0px',
  prevArrow: '<div class="slick-prev"><i style="color:#3F3A36;font-size:30px !important;" class="material-icons">keyboard_arrow_left</i></div>',
  nextArrow: '<div class="slick-next"><i style="color:#3F3A36;font-size:30px !important;" class="material-icons">keyboard_arrow_right</i></div>', 
  responsive: [
    {
    breakpoint: 1000,
    settings: {
      slidesToShow: 4,
        centerPadding: '5px',
        slidesToScroll: 2 
    }
  },
    {
      breakpoint: 768,
      settings: {
         arrows: false,
        dots: false,
        centerMode: false,
        slidesToShow: 2.5,
        slidesToScroll: 2,
        centerPadding: '5px',
        prevArrow: false,
        nextArrow:false,
        customPaging: function(slick, index) {
          return '<a><div class="custom-dot"/></a>';
        }
      }
    },
    {
      breakpoint: 480,
      settings: {
        infinite: false,
        dots: false,
        centerMode: false,
        speed:300,
        prevArrow: false,
        nextArrow:false,
        slidesToShow: 2.5,
        slidesToScroll: 2,
        centerPadding: '5px',
        customPaging: function(slick, index) {
          return '<a><div class="custom-dot"/></a>';
        }
      }
    }
  ]
});

$(".stockclear1 .slider").slick({
  arrows: true,
  dots: true,
  centerMode: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  centerPadding: '0px',
  prevArrow: '<div class="slick-prev"><i style="color:#3F3A36;font-size:30px !important;" class="material-icons">keyboard_arrow_left</i></div>',
  nextArrow: '<div class="slick-next"><i style="color:#3F3A36;font-size:30px !important;" class="material-icons">keyboard_arrow_right</i></div>',
  customPaging: function(slick, index) {
    return '<a><div class="custom-dot"/></a>';
  },
  responsive: [
    {
    breakpoint: 1000,
    settings: {
      slidesToShow: 4,
        centerPadding: '5px',
        slidesToScroll: 2 
    }
  },
    {
      breakpoint: 768,
      settings: {
         arrows: false,
        dots: true,
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        centerPadding: '5px',      
        customPaging: function(slick, index) {
          return '<a><div class="custom-dot"/></a>';
        }
      }
    },
    {
      breakpoint: 480,
      settings: {
        infinite: false,
        dots: true,
        centerMode: false,
        speed:300,
        prevArrow: false,
        nextArrow:false,
        slidesToShow: 2,
        slidesToScroll: 2,
        centerPadding: '5px',
        customPaging: function(slick, index) {
          return '<a><div class="custom-dot"/></a>';
        }
      }
    }
  ]
});


$(".stockclear2 .sliderf").slick({
  arrows: false,
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 3,
  centerPadding: '5px',
  prevArrow: '<div class="slick-prev"><i style="color:#BC944E;font-size:40px" class="material-icons">keyboard_arrow_left</i></div>',
  nextArrow: '<div class="slick-next"><i style="color:#BC944E;font-size:40px" class="material-icons">keyboard_arrow_right</i></div>',
  responsive: [
    {
    breakpoint: 1000,
    settings: {
      arrows: true,
      infinite: false,
      slidesToShow: 3,
        centerPadding: '5px',
        slidesToScroll: 2 
    }
  },
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        infinite: false,
        slidesToShow: 2,
        centerPadding: '5px',
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        infinite: false,        
        slidesToShow: 3,
        slidesToScroll: 3,
        centerPadding: '2px',
      }
    }
  ]
});

$(".product-cat .slider").slick({
  arrows: true,
    infinite: false,
    dots: false,
    centerMode: false,
  slidesToShow: 4,
  slidesToScroll: 3,
  centerPadding: '0px',
  prevArrow: '<div class="slick-prev"><i style="color:#3F3A36;font-size:30px !important" class="material-icons">keyboard_arrow_left</i></div>',
  nextArrow: '<div class="slick-next"><i style="color:#3F3A36;font-size:30px !important" class="material-icons">keyboard_arrow_right</i></div>',
  responsive: [
    {
    breakpoint: 1000,
    settings: {
        slidesToShow: 3,
        centerPadding: '5px',
        slidesToScroll: 2 
    }
  },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        autoplay: false,
        slidesToShow: 2,
        centerPadding: '5px',
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerPadding: '5px',
      }
    }
  ]
});



$(".about-us .slider").slick({
  arrows: true,
  infinite: false,
  centerMode: true,
  slidesToShow: 4,
  slidesToScroll: 3,
  centerPadding: '0px',
  prevArrow: '<div class="slick-prev"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_left</i></div>',
  nextArrow: '<div class="slick-next"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_right</i></div>',
  responsive: [
    {
    breakpoint: 1000,
    settings: {
        slidesToShow: 3,
        centerPadding: '5px',
        slidesToScroll: 2 
    }
  },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerPadding: '5px',
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        autoplay: false,
        slidesToShow: 1.5,
        slidesToScroll: 1,
        centerPadding: '5px',
      }
    }
  ]
});


// WEBPACK FOOTER //
// ./src/product.js